import { useEffect, useState } from "react"

import { ExecutionRun } from "@vertesia/common"
import { Loader, Share2 } from "lucide-react"
import { toast } from "sonner"

import { DownloadContentButton } from "@components/buttons/DownloadContentButton"
import { SaveDocumentModal } from "@components/modals/SaveDocumentModal"
import { StreamingDonePanel } from "@components/panels/streaming/StreamingDonePanel"
import { StreamingPanel } from "@components/panels/streaming/StreamingPanel"

import { useCompositeState, useGetCompositeStateProperty } from "@hooks/use-composite-state"

import FormState, { FormExecutionStatus } from "@plugins/form/FormState"

import { useUserSession } from "@session/UserSession"

import { Button } from "@ui/button"

export function ResultPanel() {
    const { project } = useUserSession()

    const formState = useCompositeState(FormState)
    const status = useGetCompositeStateProperty(formState.executionStatus)
    const [run, setRun] = useState<ExecutionRun | null>(formState.executionRun || null)

    const handleShare = () => {
        if (!window.location.hash || !project) {
            return
        }

        const url = `${window.location.origin}/assistant?a=${project.account}&p=${project.id}${window.location.hash}`
        navigator.clipboard.writeText(url)
        toast.success("Link copied", {
            description: `Link copied to clipboard`,
            duration: 2000,
        })
    }

    useEffect(() => {
        setRun(formState.executionRun || null)
    }, [status])

    return (
        <div className="w-full h-full">
            <div className="flex flex-row justify-between items-center p-2 h-[52px]">
                <h4 className="text-xl font-semibold">Result</h4>
                {status === FormExecutionStatus.streaming && <Loader className="w-5 h-5 animate-spin motion-safe:animate-[spin_3s_linear_infinite]" />}
                {status === FormExecutionStatus.done && (
                    <div className="flex items-end gap-2">
                        <Button onClick={handleShare} className="flex items-center gap-2">
                            <Share2 />
                            Share
                        </Button>
                        <SaveDocumentModal content={formState.streamingText.value || ""} title variant={"default"} size={"default"} />
                        <DownloadContentButton content={formState.streamingText.value || ""} title variant={"default"} size={"default"} />
                    </div>
                )}
            </div>
            <div className="p-2  min-h-[calc(100vh-166px)] max-h-[calc(100vh-166px)] overflow-auto">
                {status !== FormExecutionStatus.streaming && status !== FormExecutionStatus.done && <div className="text-gray-500 text-center">Run the service to see the result here</div>}
                {status === FormExecutionStatus.streaming && run?.id && <StreamingPanel run={run} />}
                {status === FormExecutionStatus.done && <StreamingDonePanel />}
            </div>
        </div>
    )
}
